import { STATE, GETTERS } from "./names";

export default {
    [GETTERS.FULL_PAGE_LOADING_VISIBLE]: (state) => state[STATE.FULL_PAGE_LOADING_VISIBLE],
    [GETTERS.FULL_PAGE_LOADING_TEXT]: (state) => state[STATE.FULL_PAGE_LOADING_TEXT],
}
